import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.codigoTiUndMat} value={props.elemento._id}>{props.elemento.descrTiUndMat}</option>
  )
};

const Lista = ({handleLista, list}) => {
    const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select className="ui simple selection dropdown fluid" name="clase" id="miLista" onChange={handleLista}>
                <option value="">Seleccionar...</option>
                {Nivel1Detalle}
            </select>
        </div>
    )
};

const AddUm2 = ({styles, list, handleLista, handleSubmit, handleChange, args, errors}) => {
    return(
        <div>
            <button className="ui right labeled icon button" style={styles.titBuscar}>
                <i className="large plus yellow icon"></i>
                Unidad matriz nueva
            </button>
            <div style={styles.box}>
                <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
                    <div className="ui one column stackable grid">
                        <div className="row container">
                            <div className="column" width="100%">
                                <Form.Field>
                                    <label style={styles.label}>Descripción</label>
                                    <Form.Input autoComplete="off" name="descrUndMat" id="descrUndMat" onChange={handleChange} placeholder='Descripción' icon={!errors.length?null: _find(errors, {path:'descrUndMat'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Tipo unidad matriz</label>
                                    <Lista list={list} styles={styles} handleLista={handleLista} />
                                </Form.Field>

                                <Button type='submit' primary fluid>
                                    Agregar
                                </Button>

                                {
                                    errors.length?<Message negative header="Los siguientes errores:"
                                    list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                                }
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default AddUm2
